<template>
    <v-card class="elevation-10">
        <v-card-title>
            <CreateModal v-on:created="getAdmins()"></CreateModal>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="admins.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs">{{ props.item.name }}</td>
                <td class="text-xs">{{ props.item.email }} <v-icon left color="error" v-if="props.item.blocked">error</v-icon></td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <EditModal :admin="props.item" v-on:created="getAdmins()"></EditModal>
                            </v-list-tile>
                            <v-list-tile>
                                <NotificationComponent :id="props.item.id" :contact="props.item" v-on:guardar="saveNotifications"></NotificationComponent>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn
                                        flat
                                        v-on:click="sendresetPassword(props.item.email)"
                                >
                                    <v-icon left>send</v-icon>Send password
                                </v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn
                                        flat
                                        @click="deleteItem(props.item.id)"
                                >
                                    <v-icon left>delete</v-icon>Delete
                                </v-btn>
                            </v-list-tile>

                            <v-list-tile v-if="props.item.blocked">
                                <v-btn
                                        flat
                                        @click="unblock(props.item.id)"
                                >
                                    <v-icon left>login</v-icon>Unblock
                                </v-btn>
                            </v-list-tile>


                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="admins.data">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
        </div>
    </v-card>
</template>

<script>
    import CreateModal from './components/CreateModal';
    import EditModal from './components/EditModal';
    import NotificationComponent from './components/NotificationsComponent';

    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {
                        text: 'Email',
                        align: 'left',
                        sortable: false,
                        value: 'email'
                    },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                admins: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition'
            }
        },
        created: function() {
            this.setSectionTitle();
            this.getAdmins();
            this.debouncedGetAdmins = _.debounce(this.getAdmins, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetAdmins();
            },
            last_page: function () {
                if (this.page > this.admins.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            saveNotifications (contact) {
                this.$store.dispatch('updateUserNotifications', contact).then((res) => {
                    this.getAdmins();
                }).catch((error) => {

                });
            },
            sendresetPassword (email) {
                this.$store.dispatch('sendResetPassword', {
                    email: email
                }).then((res) => {
                }).catch((error) => {
                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Admins.'
                });
            },
            setPage (page) {
                this.page = page;
                this.getAdmins();
            },
            getAdmins () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page
                    }
                };
                this.$store.dispatch('getAdmins', params).then((res) => {

                    this.admins = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteAdmin', {
                            id: id
                        }).then((res) => {

                            this.getAdmins();

                        }).catch((error) => {

                        });
                    }
                })
            },
            unblock (id) {
                this.$confirm('Do you really want to unblock the user?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('unblockUser', {
                            id: id
                        }).then((res) => {

                            this.getAdmins();

                        }).catch((error) => {

                        });
                    }
                })
            }
        },
        components : {
            CreateModal,
            EditModal,
            NotificationComponent
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/config/admins/AdminsComponent.vue